module.exports = __webpack_public_path__ + "static/media/icon-post-album-on.6cbbee72.svg";